import React, { Component, Fragment } from 'react';
import Breadcrumb from '../common/breadcrumb';
import Datatable from '../common/datatable'
import AuthService from "../services/auth.service";
import ApiService from "../services/api.service";

export class Log_user extends Component {
    
    constructor(props) {
        super(props);
        this.state = {
            dataCateg: [],
            results: [],
            filter: '',
            temp: [],
        };
    }

    componentWillMount() {
        this.getDataUser();
    }

    getDataUser(){
        var user = AuthService.getCurrentUser();
        ApiService.getChangeLog(user.token).then(
            (res) => {
                if(res && res.status == 'success'){
                    const items = res.data.map(function(row) {
                        return { 
                            Fecha: `${row.date} ${row.time}`,
                            Antes : row.old_value, 
                            Ahora : row.new_value,
                            Usuario: row.initials,
                            Módulo: row.module_name
                        }
                    })
                this.setState({ results:items });
                this.setState({ temp:items });
                this.renderResults(this.state.results.length);
                }
            },
            error => {
                const resMessage =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            }
            );
    }

    renderResults(length){
        return this.state.results.length === 0 
            ? 'No hay datos.'
            : <Datatable
            multiSelectOption={false}
            myData={this.state.results}
            pageSize={length<=10?length:10}
            pagination={true}
            class="-striped -highlight"
        />
    }

    render() {
        return (
            <Fragment>
                <Breadcrumb title="Log de Cambios" parent="Users" />
                <div className="container-fluid">
                    <div className="card">
                        <div className="card-header">
                            <h5>Log de cambios</h5>
                        </div>
                        <div className="card-body">
                            
                            <div className="clearfix"></div>
                            <div id="batchDelete" className="category-table user-list order-table coupon-list-delete">
                                
                                {this.renderResults()}
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
}

export default Log_user
